export default __webpack_public_path__ + "static/6contenido_blogpandabtm-8834685c447c7a9c7d33b50164b9ef38.png";